var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0073 11.0048C16.0073 11.4653 15.634 11.8385 15.1736 11.8385H11.8386V15.1736C11.8386 15.634 11.4653 16.0073 11.0049 16.0073C10.5444 16.0073 10.1711 15.634 10.1711 15.1736V11.8385H6.83618C6.37572 11.8385 6.00244 11.4653 6.00244 11.0048C6.00244 10.5443 6.37572 10.1711 6.83618 10.1711H10.1711V6.83618C10.1711 6.37572 10.5444 6.00244 11.0049 6.00244C11.4653 6.00244 11.8386 6.37572 11.8386 6.83618V10.1711H15.1736C15.634 10.1711 16.0073 10.5443 16.0073 11.0048Z",
  fill: "#9174E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0049 21.0098C16.5304 21.0098 21.0098 16.5304 21.0098 11.0049C21.0098 5.47934 16.5304 1 11.0049 1C5.47934 1 1 5.47934 1 11.0049C1 16.5304 5.47934 21.0098 11.0049 21.0098ZM11.0049 19.3423C15.6095 19.3423 19.3423 15.6095 19.3423 11.0049C19.3423 6.40026 15.6095 2.66748 11.0049 2.66748C6.40026 2.66748 2.66748 6.40026 2.66748 11.0049C2.66748 15.6095 6.40026 19.3423 11.0049 19.3423Z",
  fill: "#9174E3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0073 11.0048C16.0073 11.4653 15.634 11.8385 15.1736 11.8385H11.8386V15.1736C11.8386 15.634 11.4653 16.0073 11.0049 16.0073C10.5444 16.0073 10.1711 15.634 10.1711 15.1736V11.8385H6.83618C6.37572 11.8385 6.00244 11.4653 6.00244 11.0048C6.00244 10.5443 6.37572 10.1711 6.83618 10.1711H10.1711V6.83618C10.1711 6.37572 10.5444 6.00244 11.0049 6.00244C11.4653 6.00244 11.8386 6.37572 11.8386 6.83618V10.1711H15.1736C15.634 10.1711 16.0073 10.5443 16.0073 11.0048Z",
  stroke: "#9174E3",
  strokeWidth: 0.555827,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0049 21.0098C16.5304 21.0098 21.0098 16.5304 21.0098 11.0049C21.0098 5.47934 16.5304 1 11.0049 1C5.47934 1 1 5.47934 1 11.0049C1 16.5304 5.47934 21.0098 11.0049 21.0098ZM11.0049 19.3423C15.6095 19.3423 19.3423 15.6095 19.3423 11.0049C19.3423 6.40026 15.6095 2.66748 11.0049 2.66748C6.40026 2.66748 2.66748 6.40026 2.66748 11.0049C2.66748 15.6095 6.40026 19.3423 11.0049 19.3423Z",
  stroke: "#9174E3",
  strokeWidth: 0.555827,
  strokeLinecap: "round"
});

function SvgIconTeamPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTeamPlus);
export default __webpack_public_path__ + "static/media/icon-team-plus.a0a537a9312019aefe2a8aa7bd8d96ae.svg";
export { ForwardRef as ReactComponent };